module.exports = __webpack_public_path__ + "static/img/banner_2.1ad1217.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_2.jpg
// module id = bJZT
// module chunks = 1 2 3 4 5 6 7 8 9